<template>
    <v-dialog :value="value" @input="$emit('input', false)" max-width="400">
        <v-card>
            <v-card-title>
                {{ title }}
            </v-card-title>

            <v-card-subtitle v-if="subtitle">
                {{ subtitle }}
            </v-card-subtitle>

            <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn @click="$emit('input', false)" text>Batal</v-btn>
                <v-btn @click="confirm" text :color="color">{{ actionText }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: {
        value: {
            type: Boolean,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        subtitle: {
            type: String,
            required: false
        },
        color: {
            type: String,
            default: 'primary'
        },
        actionText: {
            type: String,
            default: 'OK'
        }
    },

    methods: {
        confirm() {
            this.$emit('input', false)
            this.$emit('confirmed')
        }
    }
}
</script>
